import { Entry, EntryCollection } from "contentful";
import { path } from "ramda";

import { useServerSideProps } from "~/contexts/server-side-props";

import { assertEditorialType, isActiveEntry } from "./editorial-utils";
import objectUtils from "./object-utils";

const translationUtils = {
  parseTranslationLabel(entry: Entry<unknown>) {
    if (!isActiveEntry(entry)) return { key: "", value: "" };
    assertEditorialType<{ key: string; value: string }>(entry, "translationLabel");

    return entry.fields;
  },
  parseMultipleTranslationLabels(collection: Omit<EntryCollection<unknown>, "stringifySafe" | "toPlainObject">) {
    const labels = collection.items.map((item) => this.parseTranslationLabel(item));
    const record = labels.reduce((acc, next) => ({ ...acc, [next.key]: next.value || null }), {});

    return objectUtils.nestDottedKeys(record);
  },
};

export function useTranslateWithFallback() {
  const { serverSideProps } = useServerSideProps();

  return function (key: string, fallback?: string | null) {
    const value = path(key.split("."))(serverSideProps.messages) as string | undefined;

    return value || fallback || key;
  };
}

export default translationUtils;
